import { render } from "./FormSecondStep.vue?vue&type=template&id=7f459fc9"
import script from "./FormSecondStep.vue?vue&type=script&lang=js"
export * from "./FormSecondStep.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__